import { render, staticRenderFns } from "./InputAttribute.global.vue?vue&type=template&id=e8620ecc&lang=pug&"
import script from "./InputAttribute.global.vue?vue&type=script&lang=ts&"
export * from "./InputAttribute.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports